import { render, staticRenderFns } from "./appCategorySelect.vue?vue&type=template&id=2f1c6904"
import script from "./appCategorySelect.vue?vue&type=script&lang=js"
export * from "./appCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports